module.exports = __webpack_public_path__ + "static/img/valBg2.1ee9197f.png";